import React from 'react';
import { getRegion } from 'utils/Region';
import { pushSelectContentEvent } from 'utils/analytics/pushSelectContentEvent';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import useRenderChapas from '../../../../../../hooks/useRenderChapas';
//-----------------------------------------------------------------------------
import { FadeInImage } from '../../../../../../components/FadeInImage';
import './style.scss';
import { useVerifyIsMobile } from '../../../../../../hooks/useVerifyIsMobile';
import { useNavigate } from 'react-router-dom';
import { getContentListV1 } from 'utils/homologacion/homologacion';
import { IMG_SIZE } from 'utils/homologacion/contants';
import { PUSHTOHISTORY } from 'constants';

export const OverlayCard = ({ contentInfo, carouselTitle, contentPosition }) => {
  const { renderLabel } = useRenderChapas();
  const { isMobile } = useVerifyIsMobile(768);
  const { nodesSelected, navigateToChannel } = useMenuRedirect();
  const navigate = useNavigate();

  const handleCardClick = e => {
    e.stopPropagation();

    pushSelectContentEvent(contentInfo, nodesSelected, carouselTitle, contentPosition);

    if (getContentListV1?.IsLive(contentInfo)) {
      // navegar al canal
      navigateToChannel(contentInfo, PUSHTOHISTORY);
      return;
    }

    //Redireccionamiento
    navigate(
      `/${getRegion()}/vcard/homeuser/${getContentListV1.titleUri(contentInfo)}/${
        contentInfo.id
      }`,
    );
  };
  return (
    <div className="overlay-card" onClick={handleCardClick}>
      {renderLabel(contentInfo)}
      <div className="overlay-card__poster">
        <FadeInImage
          imageAlt={'clarovideo'}
          imageSrc={
            isMobile ?  getContentListV1?.getImage(contentInfo,IMG_SIZE?.MEDIUM) : getContentListV1?.getImage(contentInfo,IMG_SIZE?.LARGE)
          }
          width={isMobile ? 101 : 256}
          height={isMobile ? 152 : 144}
          classNames={['overlay-card']}
        />
      </div>
      <div className="overlay-card__overlay">
        <span className="overlay-card__overlay__title">
          {contentInfo.title}
        </span>
      </div>
    </div>
  );
};
